import { Injectable } from "@angular/core";
// import { ToastComponent } from "../layout/toast/toast.component";
import { HttpClient } from "@angular/common/http";
import { Dep } from '../comm/class/auth';

/**
 * 通知訊息的介面定義
 */
interface ExtendedNotificationPayload {
  title: string;      // 通知標題
  body: string;       // 通知內容
  icon?: string;      // 通知圖示（可選）
}

@Injectable({
  providedIn: "root",
})

export class WebPushService {
  // VAPID 公鑰，用於推送服務識別應用程式
  private VAPID_PUBLIC_KEY = 'BInxuv6l_ZMRWe14EIdtt4wDDPrRBSRQl9McOAeeQryw_ERwM_N2rVqz9Ji0B5PYH9cj4rPz4ncfFLpcIG-R4xs';

  constructor(private httpClient: HttpClient) {}

  /**
   * 請求通知權限並設置 Web Push
   * 這是使用者首次啟用通知時調用的方法
   */
  async requestNotificationPermission() {
    const permission = await Notification.requestPermission();
    console.log("sw employee_id: " + Dep.getData().id);
    if (permission === "granted") {
      console.log("通知權限已授權，開始設定 Web Push...");
    } else if (permission === "denied") {
      console.warn("通知權限被拒絕，無法啟用 Web Push");
    } else {
      console.warn("使用者尚未選擇是否允許通知");
    }
    this.setupWebPush();
  }


  /**
   * 設置 Web Push 服務
   * 包括註冊 Service Worker 和設置推送訂閱
   */
  setupWebPush(): void {
    // navigator.serviceWorker.ready.then(async (registration) => {
      // const oldSub = await registration.pushManager.getSubscription();
      // if (oldSub) {
        // console.warn("⚠️ 已存在舊訂閱，強制取消");
        // await oldSub.unsubscribe();
      // }
    // });
    // 安全性檢查：確保只在 HTTPS 或 localhost 環境下運行
    if (
      location.protocol !== "https:" &&
      location.hostname !== "localhost"
    ) {
      console.warn("Web Push 只能在 HTTPS 或 localhost 環境下運行");
      return;
    }

    // 檢查瀏覽器是否支援 Service Worker
    if ("serviceWorker" in navigator) {
      // 獲取當前應用的路徑
      const temp = location.pathname.split("/");

      // 註冊新的 Service Worker
      navigator.serviceWorker
      .register("/"+temp[1]+"/sw.js")
      .then((registration) => {
        console.log("Service Worker 註冊成功:", registration);
        
        // 確保 Service Worker 已激活後才進行推送訂閱
        if (registration.active) {
          return this.subscribeToPush(registration);
        } else {
          // 如果 Service Worker 尚未激活，等待激活後再訂閱
          registration.addEventListener('activate', () => {
            return this.subscribeToPush(registration);
          });
        }
      })
      .catch((err) => {
        console.error("Service Worker 註冊失敗:", err);
      });
    } else {
      console.log("Service Worker 不支援此瀏覽器");
    }
  
    // 監聽來自 Service Worker 的推送消息
    window.addEventListener("message", (event) => {
      if (event.data && event.data.type === "PUSH_MESSAGE") {
        const data = event.data.data;
        // this.showToast(`收到通知：${data.title}`, "info");
      }
    });
  }

  /**
   * 訂閱推送服務
   * @param registration Service Worker 註冊對象
   */
  private subscribeToPush(registration: ServiceWorkerRegistration): Promise<void> {
    return registration.pushManager.getSubscription()
      .then(subscription => {
        // 如果已經訂閱過，直接返回訂閱對象
        if (subscription) {
          return subscription;
        }
        // 否則創建新的訂閱
        return registration.pushManager.subscribe({
          userVisibleOnly: true,  // 確保推送必須對用戶可見
          // applicationServerKey is obtained from a server-side call to web-push `generateVAPIDKeys()`
          applicationServerKey: this.urlBase64ToUint8Array(this.VAPID_PUBLIC_KEY)
        });
      })
      .then(subscription => {
        // Be sure to JSON.stringify the result, or you won't see the keys in the console.
        console.log("subscription: " + JSON.stringify(subscription));

        // 將訂閱信息發送到後端服務器
        this.sendSubscriptionToServer(subscription);
      })
      .catch(err => {
        console.error("訂閱失敗:", err);
      });
  }

  /**
   * 將訂閱信息發送到後端服務器
   * @param subscription 推送訂閱對象
   */
  async sendSubscriptionToServer(subscription: PushSubscription) {
    try {
      // 準備要發送到後端的訂閱數據
      const body = {
        endpoint: subscription.endpoint,        // 推送服務的 URL
        p256dh: subscription.toJSON().keys.p256dh,  // 用於加密的公鑰
        auth: subscription.toJSON().keys.auth,        // 用於加密的認證密鑰
        action: '0',
        employee_id: Dep.getData().id,
      };
      // 發送到後端 API
      this.httpClient.post<any>("/webpush/webpush.php", body).subscribe(res => {
        if(res.status){
            console.log("訂閱資訊已成功儲存於後端");
        }else{
            console.error("訂閱資訊儲存錯誤:", res.message);
        }
      }); 
    } catch (error) {
      console.error("訂閱資訊儲存錯誤:", error);
    }
  }

  /**
   * 將 base64 格式的 VAPID 公鑰轉換為 Uint8Array
   * @param base64String base64 編碼的 VAPID 公鑰
   * @returns Uint8Array 格式的公鑰
   */
  urlBase64ToUint8Array(base64String: string): Uint8Array {
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");
  
    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);
  
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  Send(employee_id: string, title: string, content: string, url: string) {
    try {
      // 準備要發送到後端的訂閱數據
      const body = {
        action: '1',  // 指定動作為發送
        employee_id: employee_id,             // 員工ID
        // 通知內容
        title: title,                          // 通知標題
        content: content,            // 通知內容
        url: url,                // 點擊通知後跳轉的URL
        icon: './assets/dist/img/logo10.png',    // 通知圖示
        image: './assets/dist/img/goodcat.jpeg',   // 通知圖片
        // 按鈕設定（可選）
        btnOne1Action: 'view',                     // 左按鈕動作
        btnOne1Title: '查看詳情',                   // 左按鈕文字
        btnOne1Url: 'https://example.com/details', // 左按鈕連結
        btnOne2Action: 'close',                    // 右按鈕動作
        btnOne2Title: '關閉',                       // 右按鈕文字
        btnOne2Url: '',                            // 右按鈕連結
        autoHide: false,                       // 是否自動隱藏
      };

      // 發送到後端 API
      this.httpClient.post<any>("/webpush/webpush.php", body).subscribe(res => {
        if(res.success) {
          console.log("推送通知發送成功:", res.message);
        } else {
          console.error("推送通知發送失敗:", res.message);
        }
      }); 
    } catch (error) {
      console.error("推送通知發送錯誤:", error);
    }
  }

  testSend() {
    try {
      // 準備要發送到後端的訂閱數據
      const body = {
        action: '1',  // 指定動作為發送
        employee_id: Dep.getData().id,             // 員工ID
        // 通知內容
        title: '測試通知',                          // 通知標題
        content: '這是一則測試通知內容。',            // 通知內容
        url: 'https://example.com',                // 點擊通知後跳轉的URL
        icon: './assets/icons/icon-72x72.png',    // 通知圖示
        image: './assets/images/icon-72x72.png',   // 通知圖片
        // 按鈕設定（可選）
        btnOne1Action: 'view',                     // 左按鈕動作
        btnOne1Title: '查看詳情',                   // 左按鈕文字
        btnOne1Url: 'https://example.com/details', // 左按鈕連結
        btnOne2Action: 'close',                    // 右按鈕動作
        btnOne2Title: '關閉',                       // 右按鈕文字
        btnOne2Url: '',                            // 右按鈕連結
        autoHide: false,                       // 是否自動隱藏
      };

      // 發送到後端 API
      this.httpClient.post<any>("/webpush/webpush.php", body).subscribe(res => {
        if(res.success) {
          console.log("推送通知發送成功:", res.message);
        } else {
          console.error("推送通知發送失敗:", res.message);
        }
      }); 
    } catch (error) {
      console.error("推送通知發送錯誤:", error);
    }
  }

}

